import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, of } from "rxjs";

import { environment } from "../../../../environments/environment";
import { formatDate } from "@angular/common";
import { AccountingDocument } from "../domains/accounting-document";
import { catchError } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class ChiftService {
  url = environment.apiUrl + "/apps-connector";

  constructor(private http: HttpClient) {}

  getChiftLoginUrl(): Observable<string> {
    return this.http.get<string>(this.url + "/chift/login");
  }

  createAccountingInvoice(invoiceId: string, connectionId: string) {
    return this.http.post<{ status: string }>(
      this.url + "/chift/create-accounting-invoice/" + connectionId + "/" + invoiceId,
      {},
    );
  }

  getChiftConnections(): Observable<any> {
    return this.http.get<any>(this.url + "/chift/connections").pipe(catchError(() => of({ connections: [] })));
  }
  getChiftVatCodes(): Observable<any> {
    return this.http.get<any>(this.url + "/chift/vats");
  }

  exportAccountingDocumentsToChift(documents: AccountingDocument[], connectionId: string) {
    return this.http.post<{ status: string }>(this.url + "/chift/export-invoices/" + connectionId, {
      documents: documents,
    });
  }
}
